/** Scroll section to top + brief highlight on header filter after chip-click filter. */
export default {
  data() {
    return {
      filterControlHighlightActive: false,
      _filterHighlightTimer: null,
    };
  },

  beforeDestroy() {
    if (this._filterHighlightTimer) {
      clearTimeout(this._filterHighlightTimer);
      this._filterHighlightTimer = null;
    }
  },

  methods: {
    applyChipFilterFeedback(sectionElementId, duration = 1500) {
      this.$nextTick(() => {
        this.scrollSectionIntoView(sectionElementId);
        this.highlightFilterControl(duration);
      });
    },

    scrollSectionIntoView(sectionElementId) {
      if (!sectionElementId) return;
      const el = document.getElementById(sectionElementId);
      if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },

    highlightFilterControl(duration = 1500) {
      this.filterControlHighlightActive = true;
      if (this._filterHighlightTimer) {
        clearTimeout(this._filterHighlightTimer);
      }
      this._filterHighlightTimer = setTimeout(() => {
        this.filterControlHighlightActive = false;
        this._filterHighlightTimer = null;
      }, duration);
    },
  },
};
